import { render } from "./AIQFunctionBox.vue?vue&type=template&id=71754f84&scoped=true&lang=pug"
import script from "./AIQFunctionBox.vue?vue&type=script&lang=js"
export * from "./AIQFunctionBox.vue?vue&type=script&lang=js"

import "./AIQFunctionBox.vue?vue&type=style&index=0&id=71754f84&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71754f84"]])

export default __exports__